/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S4_HeadingInputs */

const tr_kullanim_s4_heading = /** @type {(inputs: Kullanim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Tarafların Hak ve Yükümlülükleri`)
};

const en_kullanim_s4_heading = /** @type {(inputs: Kullanim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Rights and obligations of the parties`)
};

const de_kullanim_s4_heading = /** @type {(inputs: Kullanim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Rechte und Pflichten der Parteien`)
};

const ru_kullanim_s4_heading = /** @type {(inputs: Kullanim_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Права и обязанности сторон`)
};

/**
* | output |
* | --- |
* | "4. Rights and obligations of the parties" |
*
* @param {Kullanim_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s4_heading = /** @type {((inputs?: Kullanim_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s4_heading(inputs)
	if (locale === "de") return de_kullanim_s4_heading(inputs)
	if (locale === "ru") return ru_kullanim_s4_heading(inputs)
	return tr_kullanim_s4_heading(inputs)
});